import api from './api';
import { Order } from './orders';

export interface Dealer {
  id: string;
  username: string;
  email: string;
  discountPercent?: number;
  active?: boolean;
  createdAt: string;
  revenue?: {
    lastMonth: number;
    currentMonth: number;
  };
  _count?: {
    orders: number;
  };
}

export interface DealerWithOrders extends Dealer {
  orders: Order[];
}

export const getAllDealers = async (): Promise<Dealer[]> => {
  const response = await api.get<Dealer[]>('/admin/dealers');
  return response.data;
};

export const getDealerWithOrders = async (id: string): Promise<DealerWithOrders> => {
  const response = await api.get<DealerWithOrders>(`/admin/dealers/${id}`);
  return response.data;
};

export const updateDealerDiscount = async (
  id: string,
  discountPercent: number
): Promise<Dealer> => {
  const response = await api.patch<Dealer>(`/admin/dealers/${id}/discount`, { discountPercent });
  return response.data;
};

export const sendPasswordSetupEmail = async (
  id: string
): Promise<{ success: boolean; message: string }> => {
  const response = await api.post<{ success: boolean; message: string }>(
    `/admin/dealers/${id}/send-password-setup`
  );
  return response.data;
};

export const updateDealerActive = async (id: string, active: boolean): Promise<Dealer> => {
  const response = await api.patch<Dealer>(`/admin/dealers/${id}/active`, { active });
  return response.data;
};
